export default {
	id: "galaxy-s8",
	title: "Galaxy S8",
	company: "Samsung",
	border: "0px",
	borderRadius: "0.86em",
	colorSide: true,
	overlay: {
		img: require("./original/glare.png")
	},
	styles: [
		{
			title: "normal",
			pos: ["5.6%", "3.1%", "5%", "3.1%"],
			colors: [
				{
					title: "Midnight Black",
					hex: "#090909",
					img: require("./original/black.png")
				},
				{
					title: "Orchid Grey",
					hex: "#cbc7db",
					img: require("./original/grey.png")
				},
				{
					title: "Arctic Silver",
					hex: "#e4e7eb",
					img: require("./original/silver.png")
				},
				{
					title: "Maple Gold",
					hex: "#ecd9cb",
					img: require("./original/gold.png")
				},
				{
					title: "Coral Blue",
					hex: "#a5c7f4",
					img: require("./original/blue.png")
				}
			]
		}
	]
};
